<template>
  <div class="homePop" v-show="show" @click="show=false">
    <div class="pxindBox">
      <img  class="pxind" src="@/assets/img/arkHome/wx-share.png" />
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      show: false,
    };
  },
  components: {},

  created() {},

  mounted() {
  },
  watch: {},
  methods: {
  },
};
</script>
<style lang="scss" scoped>
.homePop {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 2001;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.pxindBox {
  position: absolute;
  top: 0;
  right: 30px;
  width: 500px;
  height: 644px;
  margin: 0 auto;
}
.pxind {
  width: 100%;
}
</style>
